import useAuthorization from './useAuthorization'

const AuthorizedComponent = ({ roles, children }) => {
    const { isAuthorized } = useAuthorization(roles)

    return isAuthorized ? children : null
}

export default AuthorizedComponent
